import script from "./NewCustomerHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./NewCustomerHistory.vue?vue&type=script&setup=true&lang=js"

import "./NewCustomerHistory.vue?vue&type=style&index=0&id=7855a052&lang=scss&scoped=true"
import "./NewCustomerHistory.vue?vue&type=style&index=1&id=7855a052&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7855a052"]])

export default __exports__